import { Observable } from 'rxjs';

import { Response } from '@shure/shared/angular/data-access/system-api/models';

import { BypassDspDevice } from '../models';

export abstract class BypassDspApiService {
	public abstract getDevice$(deviceId: string): Observable<BypassDspDevice>;
	public abstract bypassIntellimix(deviceId: string, bypassed: boolean): Observable<Response<void, string>>;
	public abstract bypassAllEq(deviceId: string, bypassed: boolean): Observable<Response<void, string>>;
}
